import React, {useContext, useState} from 'react';

import {AuthContext} from '../../context';
import {modifyPassword, updateApiKey} from '../../api';
import {unauthorized} from '../../utils';
import {
  Button,
  Input,
  InputSecured,
  Modal,
  Notification,
  PageContainer,
  Section,
} from '../../components';

const DashboardCustomer = ({history}) => {
  const {user, dispatch} = useContext(AuthContext);
  const [showKey, setShowKey] = useState(false);
  const [copied, setCopied] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [oldPassword, setOldPassword] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [notif, setNotif] = useState();

  const handleUpdateApiKey = async () => {
    setIsOpen(!isOpen);
    setNotif();

    const {error} = await updateApiKey(user.company._id, dispatch);
    await unauthorized(error, history);
    if (error) return setNotif({type: 'error', text: error});

    setNotif({
      type: 'success',
      text: 'Votre clef a bien été mise à jour.',
    });
  };

  const modifyPasswordHandler = async (e) => {
    e.preventDefault();
    setNotif();

    if (password !== confirmPassword) {
      setTimeout(() => {
        setNotif('');
      }, 2000);
      return setNotif({type: 'error', text: 'Les mots de passe de correspondent pas.'});
    }

    const {data, error} = await modifyPassword(user.infos._id, oldPassword, password);
    await unauthorized(error, history);
    if (error) return setNotif({type: 'error', text: error});

    setNotif({type: 'success', text: data});
    setOldPassword('');
    setPassword('');
    setConfirmPassword('');
  };

  const handleOpenModal = () => {
    setIsOpen(!isOpen);
    setCopied(false);
  };

  const handleDisabled = () => {
    if (
      oldPassword.length === 0 ||
      password.length === 0 ||
      confirmPassword.length === 0
    ) {
      return true;
    }
  };

  return (
    <PageContainer
      title="Mon compte"
      role={user.infos.role}
      companyName={user.company.name}
      history={history}
    >
      <Section title="API Key">
        <div className="dashboard-info">
          <InputSecured
            value={user.company.apiKey}
            copied={copied}
            handleCopy={() => setCopied(true)}
            handleShowText={() => setShowKey(!showKey)}
            showText={showKey}
            apikey
            readOnly
          />
          <button onClick={handleOpenModal} className="button-newkey">
            Générer une nouvelle clé API
          </button>
          {isOpen && (
            <Modal
              closeModal={() => setIsOpen(!isOpen)}
              handleClick={handleUpdateApiKey}
              title="Êtes-vous sûr de vouloir générer unne nouvelle clé API ?"
            />
          )}
        </div>
      </Section>
      <Section title="Sécurité">
        <form onSubmit={modifyPasswordHandler} className="modify-password-form">
          <div>
            <Input
              label="Votre ancien mot de passe"
              type="password"
              name="oldPassword"
              value={oldPassword}
              handleChange={(e) => setOldPassword(e.target.value)}
              minLength="6"
              required
              dark
            />
            <Input
              label="Votre nouveau mot de passe"
              type="password"
              name="password"
              value={password}
              handleChange={(e) => setPassword(e.target.value)}
              minLength="6"
              required
              dark
            />
            <Input
              label="Confirmez votre nouveau mot de passe"
              type="password"
              name="confirmPassword"
              value={confirmPassword}
              handleChange={(e) => setConfirmPassword(e.target.value)}
              minLength="6"
              required
              dark
            />
          </div>
          <Button type="submit" label="Modifier" disabled={handleDisabled()} light />
        </form>
      </Section>
      {notif && <Notification type={notif.type} text={notif.text} />}
    </PageContainer>
  );
};

export default DashboardCustomer;
